// extracted by mini-css-extract-plugin
module.exports = {"lia-disabled":"NavbarAnchor_lia-disabled__IqfY3"};